import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function LandingPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        body { font-family: 'Inter', sans-serif; background: #fff; color: #111; -webkit-font-smoothing: antialiased; }
        button { font-family: inherit; cursor: pointer; }
        img { display: block; max-width: 100%; }

        .nav { height: 64px; background: #fff; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between; padding: 0 40px; position: sticky; top: 0; z-index: 200; }
        .nav-logo { display: flex; align-items: center; gap: 10px; cursor: pointer; }
        .nav-logo-name { font-size: 15px; font-weight: 700; color: #00897B; line-height: 1.1; }
        .nav-logo-sub { font-size: 9.5px; color: #6b7280; font-weight: 400; }
        .nav-btns { display: flex; align-items: center; gap: 10px; }
        .btn-login { padding: 8px 18px; border-radius: 7px; border: 1.5px solid #00897B; background: none; font-size: 13px; font-weight: 600; color: #00897B; transition: background .15s; }
        .btn-login:hover { background: #E0F2F1; }
        .btn-join { padding: 8px 18px; border-radius: 7px; border: none; background: #00897B; font-size: 13px; font-weight: 600; color: #fff; transition: background .15s; }
        .btn-join:hover { background: #00695C; }
        .nav-hamburger { display: none; width: 36px; height: 36px; border-radius: 7px; border: 1px solid #e5e7eb; background: none; align-items: center; justify-content: center; flex-shrink: 0; }
        .nav-hamburger svg { width: 16px; height: 16px; stroke: #374151; fill: none; stroke-width: 2; stroke-linecap: round; }

        .mobile-menu { display: none; position: absolute; top: 64px; left: 0; right: 0; background: #fff; border-bottom: 1px solid #e5e7eb; padding: 12px 16px; flex-direction: row; align-items: center; gap: 8px; z-index: 199; }
        .mobile-menu.open { display: flex; }
        .mobile-menu .btn-login { flex: 1; text-align: center; height: 38px; padding: 0 12px; font-size: 13px; }
        .mobile-menu .btn-join { flex: 1; text-align: center; height: 38px; padding: 0 12px; font-size: 13px; }

        .hero { display: grid; grid-template-columns: 1fr 1fr; min-height: 520px; }
        .hero-left { padding: 64px 48px 64px 40px; display: flex; flex-direction: column; justify-content: center; }
        .hero h1 { font-size: 36px; font-weight: 700; color: #0f172a; line-height: 1.2; margin-bottom: 18px; }
        .hero h1 span { color: #00897B; }
        .hero-desc { font-size: 14.5px; color: #4b5563; line-height: 1.75; margin-bottom: 32px; max-width: 460px; }
        .hero-btns { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 24px; }
        .btn-hero-p { padding: 12px 26px; border-radius: 8px; border: none; background: #00897B; font-size: 14px; font-weight: 600; color: #fff; transition: background .15s; }
        .btn-hero-p:hover { background: #00695C; }
        .btn-hero-o { padding: 12px 26px; border-radius: 8px; border: 1.5px solid #e5e7eb; background: none; font-size: 14px; font-weight: 500; color: #374151; transition: background .15s; }
        .btn-hero-o:hover { background: #f9fafb; }
        .hero-trust { display: flex; align-items: center; gap: 7px; font-size: 11.5px; color: #9ca3af; flex-wrap: wrap; }
        .hero-trust-dot { width: 5px; height: 5px; border-radius: 50%; background: #16a34a; flex-shrink: 0; }
        .hero-right { position: relative; overflow: hidden; }
        .hero-img { width: 100%; height: 100%; object-fit: cover; }
        .hero-overlay { position: absolute; inset: 0; background: linear-gradient(to right, rgba(255,255,255,0.08), rgba(0,137,123,0.06)); }

        .stats-bar { background: #00897B; display: grid; grid-template-columns: repeat(4,1fr); }
        .stat-item { padding: 26px 16px; text-align: center; border-right: 1px solid rgba(255,255,255,0.12); }
        .stat-item:last-child { border-right: none; }
        .stat-n { font-size: 28px; font-weight: 700; color: #fff; margin-bottom: 4px; line-height: 1; }
        .stat-l { font-size: 11.5px; color: rgba(255,255,255,0.6); }

        .section { padding: 68px 40px; max-width: 1100px; margin: 0 auto; }
        .sec-tag { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .1em; color: #00897B; margin-bottom: 10px; }
        .sec-title { font-size: 26px; font-weight: 700; color: #0f172a; margin-bottom: 12px; line-height: 1.25; }
        .sec-sub { font-size: 14px; color: #6b7280; line-height: 1.75; max-width: 540px; margin-bottom: 40px; }

        .modules-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 14px; }
        .mod-card { border: 1px solid #e5e7eb; border-radius: 12px; padding: 22px; transition: border-color .15s, transform .15s; }
        .mod-card:hover { border-color: #00897B; transform: translateY(-2px); }
        .mod-icon { width: 42px; height: 42px; border-radius: 10px; background: #E0F2F1; display: flex; align-items: center; justify-content: center; margin-bottom: 14px; }
        .mod-icon svg { width: 20px; height: 20px; stroke: #00897B; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
        .mod-title { font-size: 13.5px; font-weight: 700; color: #0f172a; margin-bottom: 7px; }
        .mod-desc { font-size: 12px; color: #6b7280; line-height: 1.65; }
        .mod-tag { display: inline-block; margin-top: 10px; font-size: 10px; font-weight: 600; padding: 3px 9px; border-radius: 20px; background: #E0F2F1; color: #00897B; }

        .lab-section { background: #f8fafc; border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb; }
        .lab-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; }
        .lab-img-wrap { overflow: hidden; }
        .lab-img { width: 100%; height: 100%; min-height: 400px; object-fit: cover; }
        .lab-content { padding: 60px 52px; display: flex; flex-direction: column; justify-content: center; }
        .lab-content .sec-sub { margin-bottom: 24px; }
        .lab-feats { display: flex; flex-direction: column; gap: 14px; }
        .lab-feat { display: flex; align-items: flex-start; gap: 11px; }
        .lab-feat-icon { width: 34px; height: 34px; border-radius: 8px; background: #E0F2F1; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .lab-feat-icon svg { width: 16px; height: 16px; stroke: #00897B; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
        .lab-feat-title { font-size: 13px; font-weight: 600; color: #0f172a; margin-bottom: 2px; }
        .lab-feat-desc { font-size: 11.5px; color: #6b7280; line-height: 1.6; }

        .req-section { background: #00897B; }
        .req-inner { max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; }
        .req-content { padding: 60px 52px 60px 40px; display: flex; flex-direction: column; justify-content: center; }
        .req-content .sec-tag { color: #B2DFDB; }
        .req-content .sec-title { color: #fff; }
        .req-content .sec-sub { color: rgba(255,255,255,0.6); margin-bottom: 24px; }
        .req-steps { display: flex; flex-direction: column; gap: 12px; margin-bottom: 28px; }
        .req-step { display: flex; align-items: flex-start; gap: 11px; }
        .req-step-num { width: 26px; height: 26px; border-radius: 50%; background: rgba(255,255,255,0.15); display: flex; align-items: center; justify-content: center; font-size: 11.5px; font-weight: 700; color: #fff; flex-shrink: 0; }
        .req-step-title { font-size: 13px; font-weight: 600; color: #fff; margin-bottom: 2px; }
        .req-step-desc { font-size: 11.5px; color: rgba(255,255,255,0.55); line-height: 1.6; }
        .btn-req { padding: 11px 26px; border-radius: 8px; border: none; background: #fff; font-size: 13.5px; font-weight: 600; color: #00897B; width: fit-content; transition: opacity .15s; }
        .btn-req:hover { opacity: .92; }
        .req-img-wrap { overflow: hidden; }
        .req-img { width: 100%; height: 100%; min-height: 380px; object-fit: cover; opacity: .85; }

        .roles-section { padding: 68px 40px; max-width: 1100px; margin: 0 auto; }
        .role-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 14px; margin-top: 36px; }
        .role-card { border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; display: flex; flex-direction: column; transition: border-color .15s; }
        .role-card:hover { border-color: #00897B; }
        .role-img { width: 100%; height: 145px; object-fit: cover; background: #f3f4f6; }
        .role-body { padding: 18px 20px; }
        .role-name { font-size: 13.5px; font-weight: 700; color: #0f172a; margin-bottom: 5px; }
        .role-desc { font-size: 12px; color: #6b7280; line-height: 1.65; }

        .compliance-section { background: #f8fafc; border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb; padding: 56px 40px; }
        .compliance-inner { max-width: 1100px; margin: 0 auto; }
        .compliance-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 14px; margin-top: 32px; }
        .comp-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 20px; text-align: center; }
        .comp-icon { width: 42px; height: 42px; border-radius: 10px; background: #E0F2F1; display: flex; align-items: center; justify-content: center; margin: 0 auto 11px; }
        .comp-icon svg { width: 20px; height: 20px; stroke: #00897B; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
        .comp-title { font-size: 13px; font-weight: 700; color: #0f172a; margin-bottom: 5px; }
        .comp-desc { font-size: 11.5px; color: #6b7280; line-height: 1.6; }

        .cta-section { padding: 80px 40px; text-align: center; background: #fff; }
        .cta-inner { max-width: 580px; margin: 0 auto; }
        .cta-inner h2 { font-size: 30px; font-weight: 700; color: #0f172a; margin-bottom: 14px; line-height: 1.25; }
        .cta-inner p { font-size: 14px; color: #6b7280; line-height: 1.75; margin-bottom: 30px; }
        .cta-btns { display: flex; align-items: center; justify-content: center; gap: 10px; flex-wrap: wrap; }
        .btn-cta-p { padding: 12px 30px; border-radius: 8px; border: none; background: #00897B; font-size: 14px; font-weight: 600; color: #fff; transition: background .15s; }
        .btn-cta-p:hover { background: #00695C; }
        .btn-cta-o { padding: 12px 30px; border-radius: 8px; border: 1.5px solid #e5e7eb; background: none; font-size: 14px; font-weight: 500; color: #374151; transition: background .15s; }
        .btn-cta-o:hover { background: #f9fafb; }

        .footer { background: #0f172a; padding: 40px; display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 24px; }
        .footer-left { display: flex; flex-direction: column; gap: 8px; }
        .footer-brand-row { display: flex; align-items: center; gap: 9px; }
        .footer-brand-name { font-size: 13.5px; font-weight: 700; color: #fff; }
        .footer-copy { font-size: 11px; color: rgba(255,255,255,0.28); line-height: 1.65; }
        .footer-cols { display: flex; gap: 40px; flex-wrap: wrap; }
        .footer-col-title { font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: rgba(255,255,255,0.35); margin-bottom: 11px; }
        .footer-link { display: block; font-size: 12px; color: rgba(255,255,255,0.45); background: none; border: none; cursor: pointer; margin-bottom: 7px; text-align: left; transition: color .1s; padding: 0; }
        .footer-link:hover { color: rgba(255,255,255,0.85); }

        @media (max-width: 1024px) {
          .modules-grid { grid-template-columns: repeat(2,1fr); }
          .compliance-grid { grid-template-columns: repeat(2,1fr); }
          .stats-bar { grid-template-columns: repeat(2,1fr); }
          .stat-item:nth-child(2) { border-right: none; }
          .stat-item:nth-child(3) { border-top: 1px solid rgba(255,255,255,0.12); }
        }
        @media (max-width: 768px) {
          .nav { padding: 0 16px; height: 56px; }
          .nav-btns { display: none; }
          .nav-hamburger { display: flex; }
          .mobile-menu { top: 56px; }
          .hero { grid-template-columns: 1fr; min-height: auto; }
          .hero-left { padding: 36px 20px 28px; }
          .hero h1 { font-size: 24px; }
          .hero-desc { font-size: 13.5px; margin-bottom: 20px; }
          .hero-right { height: 200px; }
          .hero-btns { gap: 8px; }
          .stats-bar { grid-template-columns: repeat(2,1fr); }
          .stat-item { padding: 18px 12px; }
          .stat-n { font-size: 22px; }
          .stat-l { font-size: 11px; }
          .section { padding: 44px 20px; }
          .sec-title { font-size: 21px; }
          .sec-sub { font-size: 13px; margin-bottom: 28px; }
          .modules-grid { grid-template-columns: 1fr; gap: 10px; }
          .lab-inner { grid-template-columns: 1fr; }
          .lab-img { min-height: 200px; }
          .lab-content { padding: 28px 20px; }
          .req-inner { grid-template-columns: 1fr; }
          .req-content { padding: 28px 20px; }
          .req-img-wrap { display: none; }
          .roles-section { padding: 44px 20px; }
          .role-grid { grid-template-columns: 1fr; gap: 10px; }
          .compliance-section { padding: 36px 20px; }
          .compliance-grid { grid-template-columns: repeat(2,1fr); gap: 10px; }
          .cta-section { padding: 48px 20px; }
          .cta-inner h2 { font-size: 22px; }
          .cta-inner p { font-size: 13px; }
          .cta-btns { flex-direction: column; align-items: stretch; }
          .btn-cta-p, .btn-cta-o { text-align: center; width: 100%; }
          .footer { padding: 28px 20px; flex-direction: column; gap: 20px; }
          .footer-cols { gap: 20px; }
        }
        @media (max-width: 480px) {
          .nav { padding: 0 14px; }
          .hero h1 { font-size: 21px; }
          .hero-btns { flex-direction: column; }
          .btn-hero-p, .btn-hero-o { width: 100%; text-align: center; }
          .compliance-grid { grid-template-columns: 1fr; }
          .footer-cols { flex-direction: column; gap: 20px; }
          .sec-title { font-size: 19px; }
          .mod-card { padding: 16px; }
          .comp-card { padding: 16px; }
        }
      `}</style>

      {/* NAVBAR */}
      <nav className="nav">
        <div className="nav-logo" onClick={() => window.scrollTo({ top:0, behavior:"smooth" })}>
          <img src="/micronlabs.png" alt="MicronLabs Logo" style={{ width:"38px", height:"38px", borderRadius:"9px", objectFit:"contain", flexShrink:0 }}/>
          <div>
            <div className="nav-logo-name">MicronLabs</div>
            <div className="nav-logo-sub">Laboratory Information System</div>
          </div>
        </div>
        <div className="nav-btns">
          <button className="btn-login" onClick={() => navigate("/login")}>Log in</button>
          <button className="btn-join" onClick={() => navigate("/signup")}>Join now</button>
        </div>
        <button className="nav-hamburger" onClick={() => setMenuOpen(o => !o)}>
          <svg viewBox="0 0 24 24">
            {menuOpen
              ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
              : <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>
            }
          </svg>
        </button>
      </nav>

      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <button className="btn-login" onClick={() => { navigate("/login"); setMenuOpen(false); }}>Log in</button>
        <button className="btn-join" onClick={() => { navigate("/signup"); setMenuOpen(false); }}>Join now</button>
      </div>

      {/* HERO */}
      <div className="hero">
        <div className="hero-left">
          <h1>The complete <span>Lab Information</span> Management System</h1>
          <p className="hero-desc">MicronLabs LIMS digitises your entire laboratory workflow — from online test requisitions and sample tracking to automated result ingestion, PDF reports and patient portal access. Built for American healthcare providers and CLIA-certified laboratories.</p>
          <div className="hero-btns">
            <button className="btn-hero-p" onClick={() => navigate("/signup")}>Get started free</button>
            <button className="btn-hero-o" onClick={() => navigate("/login")}>Sign in</button>
          </div>
          <div className="hero-trust">
            <span className="hero-trust-dot"></span>
            HIPAA compliant &nbsp;·&nbsp; CLIA ready &nbsp;·&nbsp; 256-bit SSL encrypted
          </div>
        </div>
        <div className="hero-right">
          <img className="hero-img" src="https://images.unsplash.com/photo-1576671081837-49000212a370?w=900&auto=format&fit=crop&q=80" alt="Medical laboratory"/>
          <div className="hero-overlay"></div>
        </div>
      </div>

      {/* STATS BAR */}
      <div className="stats-bar">
        {[
          { n:"10,000+", l:"Patients registered" },
          { n:"500+",    l:"Clinicians onboard" },
          { n:"50+",     l:"Partner facilities" },
          { n:"99.9%",   l:"System uptime" },
        ].map((s, i) => (
          <div key={i} className="stat-item">
            <div className="stat-n">{s.n}</div>
            <div className="stat-l">{s.l}</div>
          </div>
        ))}
      </div>

      {/* CORE MODULES */}
      <div className="section">
        <div className="sec-tag">Core modules</div>
        <div className="sec-title">Every module your lab needs</div>
        <div className="sec-sub">MicronLabs LIMS covers all six core functional modules required by modern diagnostic laboratories — from secure authentication to analyzer integration.</div>
        <div className="modules-grid">
          {[
            { title:"Secure authentication", desc:"Role-based login with MFA and session management. Separate access levels for patients, technicians, physicians, facility clients and admins.", tag:"MFA enabled", icon:<><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></> },
            { title:"E-Requisition system", desc:"Facility clients and physicians submit online test orders through the portal. Requisitions are assigned barcodes, routed to the correct lab and tracked in real time.", tag:"Barcode enabled", icon:<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h7v7"/></> },
            { title:"Analyzer integration", desc:"Automatic result ingestion from laboratory analyzers via HL7. Results are parsed, validated and loaded into the system without manual data entry.", tag:"HL7 ready", icon:<><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></> },
            { title:"Result viewer and PDF", desc:"View and download formatted PDF result reports from any device. Results are stored securely and shared with referring physicians instantly.", tag:"PDF download", icon:<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8"/></> },
            { title:"Patient portal", desc:"Patients self-register, view their own results, track pending orders and access their full diagnostic history — without calling the lab.", tag:"Self-service", icon:<><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></> },
            { title:"Admin dashboard", desc:"Manage users, test menus, facilities and analyzer setup from one central panel. Full audit logs, access control and system configuration included.", tag:"Full control", icon:<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></> },
          ].map((m, i) => (
            <div key={i} className="mod-card">
              <div className="mod-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{m.icon}</svg>
              </div>
              <div className="mod-title">{m.title}</div>
              <div className="mod-desc">{m.desc}</div>
              <span className="mod-tag">{m.tag}</span>
            </div>
          ))}
        </div>
      </div>

      {/* LABORATORY SECTION */}
      <div className="lab-section">
        <div className="lab-inner">
          <div className="lab-img-wrap">
            <img className="lab-img" src="https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&auto=format&fit=crop&q=80" alt="Medical laboratory equipment"/>
          </div>
          <div className="lab-content">
            <div className="sec-tag">Laboratory diagnostics</div>
            <div className="sec-title">Full-spectrum lab testing</div>
            <p className="sec-sub">MicronLabs supports CLIA-certified laboratories offering the full range of diagnostic services — with results delivered digitally to patients and referring physicians across the United States.</p>
            <div className="lab-feats">
              {[
                { title:"Hematology and clinical chemistry", desc:"CBC, CMP, lipid panels, HbA1c, thyroid function and liver and kidney profiles.", icon:<><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/></> },
                { title:"Microbiology and anatomic pathology", desc:"Culture and sensitivity, surgical pathology, cytology, serology and molecular diagnostics.", icon:<><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></> },
                { title:"Real-time specimen tracking", desc:"Barcoded specimens tracked from collection through analysis with automated notifications.", icon:<><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></> },
                { title:"Digital PDF reports", desc:"Formatted result reports generated automatically and available for immediate download.", icon:<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6"/></> },
              ].map((f, i) => (
                <div key={i} className="lab-feat">
                  <div className="lab-feat-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{f.icon}</svg>
                  </div>
                  <div>
                    <div className="lab-feat-title">{f.title}</div>
                    <div className="lab-feat-desc">{f.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* E-REQUISITION */}
      <div className="req-section">
        <div className="req-inner">
          <div className="req-content">
            <div className="sec-tag">E-Requisition</div>
            <div className="sec-title">Order lab tests online</div>
            <p className="sec-sub">Physicians, clinics and healthcare facilities submit digital test orders through the portal. No paper forms. No phone calls. Specimens are collected, barcoded and routed automatically.</p>
            <div className="req-steps">
              {[
                { n:"1", title:"Submit a test order", desc:"The physician or facility client selects the required tests and submits the digital requisition." },
                { n:"2", title:"Specimen collection and barcoding", desc:"A unique barcode is generated and the lab technician collects and scans the specimen." },
                { n:"3", title:"Analysis and result entry", desc:"The analyzer processes the specimen. Results are ingested via HL7 or entered by the technician." },
                { n:"4", title:"PDF report and notification", desc:"A formatted report is generated and both the patient and ordering physician are notified." },
              ].map((s, i) => (
                <div key={i} className="req-step">
                  <div className="req-step-num">{s.n}</div>
                  <div>
                    <div className="req-step-title">{s.title}</div>
                    <div className="req-step-desc">{s.desc}</div>
                  </div>
                </div>
              ))}
            </div>
            <button className="btn-req" onClick={() => navigate("/signup")}>Place a test order</button>
          </div>
          <div className="req-img-wrap">
            <img className="req-img" src="https://images.unsplash.com/photo-1581056771107-24ca5f033842?w=700&auto=format&fit=crop&q=80" alt="Lab requisition"/>
          </div>
        </div>
      </div>

      {/* WHO IT'S FOR */}
      <div className="roles-section">
        <div className="sec-tag">Who it's for</div>
        <div className="sec-title">Built for every role in the lab workflow</div>
        <div className="sec-sub">MicronLabs LIMS serves all stakeholders in the diagnostic process — from the patient to the laboratory director.</div>
        <div className="role-grid">
          {[
            { name:"Patients", desc:"Self-register, track pending test orders and access your complete diagnostic history and PDF results from the patient portal.", img:"https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&auto=format&fit=crop&q=80", alt:"Patient" },
            { name:"Physicians and clinics", desc:"Submit digital test orders, monitor specimen status in real time and receive instant notifications when results are available.", img:"https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&auto=format&fit=crop&q=80", alt:"Physician" },
            { name:"Lab technicians and MLTs", desc:"Receive test orders, process specimens, upload results and flag critical values. HL7 integration eliminates manual transcription entirely.", img:"https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=600&auto=format&fit=crop&q=80", alt:"Lab technician" },
            { name:"Laboratory directors and admins", desc:"Manage user accounts, test menus, facility configurations and analyzer integrations. Access complete audit trails from the admin dashboard.", img:"https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&auto=format&fit=crop&q=80", alt:"Lab director" },
          ].map((r, i) => (
            <div key={i} className="role-card">
              <img className="role-img" src={r.img} alt={r.alt}/>
              <div className="role-body">
                <div className="role-name">{r.name}</div>
                <div className="role-desc">{r.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* COMPLIANCE */}
      <div className="compliance-section">
        <div className="compliance-inner">
          <div className="sec-tag">Compliance and standards</div>
          <div className="sec-title">Built to US regulatory standards</div>
          <p className="sec-sub" style={{ marginBottom:0 }}>MicronLabs LIMS meets the compliance requirements of US healthcare regulations and laboratory accreditation bodies.</p>
          <div className="compliance-grid">
            {[
              { title:"HIPAA compliant", desc:"Full HIPAA compliance for protected health information storage, transmission and access control.", icon:<><path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/><path d="M9 12l2 2 4-4"/></> },
              { title:"CLIA ready", desc:"Designed to support CLIA-certified laboratory operations and quality assurance documentation.", icon:<><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/><path d="M6 13h12"/></> },
              { title:"SOC 2 aligned", desc:"Security controls aligned with SOC 2 Type II for data security, availability and confidentiality.", icon:<><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></> },
              { title:"HL7 and FHIR", desc:"Native HL7 v2.x messaging and FHIR-ready API for interoperability with US EHR and HIS systems.", icon:<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8"/></> },
            ].map((c, i) => (
              <div key={i} className="comp-card">
                <div className="comp-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{c.icon}</svg>
                </div>
                <div className="comp-title">{c.title}</div>
                <div className="comp-desc">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="cta-section">
        <div className="cta-inner">
          <h2>Ready to modernise your laboratory?</h2>
          <p>Join independent labs, hospital systems and physician group practices across the United States already using MicronLabs LIMS. Registration is free and setup takes less than ten minutes.</p>
          <div className="cta-btns">
            <button className="btn-cta-p" onClick={() => navigate("/signup")}>Create your account</button>
            <button className="btn-cta-o" onClick={() => navigate("/login")}>Sign in</button>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-left">
          <div className="footer-brand-row">
            <img src="/micronlabs.png" alt="MicronLabs Logo" style={{ width:"28px", height:"28px", borderRadius:"7px", objectFit:"contain", flexShrink:0 }}/>
            <span className="footer-brand-name">MicronLabs on Demand</span>
          </div>
          <div className="footer-copy">
            Laboratory Information Management System<br/>
            © 2026 MicronLabs on Demand. All rights reserved.<br/>
            United States of America
          </div>
        </div>
        <div className="footer-cols">
          <div>
            <div className="footer-col-title">Platform</div>
            <button className="footer-link">E-Requisition</button>
            <button className="footer-link">Lab results</button>
            <button className="footer-link">Patient portal</button>
            <button className="footer-link">Admin dashboard</button>
          </div>
          <div>
            <div className="footer-col-title">Users</div>
            <button className="footer-link">Patients</button>
            <button className="footer-link">Physicians</button>
            <button className="footer-link">Lab technicians</button>
            <button className="footer-link">Lab directors</button>
            <button className="footer-link">Facility clients</button>
          </div>
          <div>
            <div className="footer-col-title">Company</div>
            <button className="footer-link">About us</button>
            <button className="footer-link">HIPAA notice</button>
            <button className="footer-link">Privacy policy</button>
            <button className="footer-link">Terms of service</button>
            <button className="footer-link">Contact us</button>
          </div>
        </div>
      </footer>
    </>
  );
}